import { render, staticRenderFns } from "./destinations.vue?vue&type=template&id=4df5d08f&scoped=true"
import script from "./destinations.vue?vue&type=script&lang=js"
export * from "./destinations.vue?vue&type=script&lang=js"
import style0 from "./destinations.vue?vue&type=style&index=0&id=4df5d08f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5d08f",
  null
  
)

export default component.exports